export default "__VITE_ASSET__B9_oQFj7__"